<!-- components/ChatInput.vue -->
<template>
  <div class="input-container">
    <n-input
        v-model:value="input"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 6 }"
        placeholder="输入消息...（Shift + Enter 换行）"
        :disabled="loading"
        @keydown="handleKeydown"
    />

    <div class="actions">
      <n-button
          type="primary"
          :disabled="!input.trim() || loading"
          :loading="loading"
          @click="send"
      >
        发送
      </n-button>
      <n-button v-if="loading" text @click="stop">
        停止生成
      </n-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { NInput, NButton } from 'naive-ui'
import { useChat } from '@/composables/useChat'

const { sendMessage, loading, stopStreaming } = useChat()
const input = ref('')

function handleKeydown(e) {
  // Shift + Enter：插入换行，不阻止默认行为
  if (e.key === 'Enter' && e.shiftKey) {
    // 不需要额外操作，textarea 默认就会换行
    return
  }

  // 单独按 Enter：发送消息，阻止默认提交行为
  if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault()  // 关键：阻止 Naive UI 默认的表单提交或换行+提交
    send()
  }
}

function send() {
  if (!input.value.trim() || loading.value) return
  sendMessage(input.value.trim())
  input.value = ''
}

function stop() {
  stopStreaming()
}
</script>

<style scoped>
.input-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.actions {
  margin-top: 12px;
  text-align: right;
}
</style>